export const ANALYTICS_FILTER_TYPE = 'default'
export const CALL_EXPLORER_FILTER_TYPE = 'call_explorer'
export const SENTIMENT_FILTER_TYPE = 'sentiment'
export const COPILOT_FILTER_TYPE = 'copilot'
export const INBOX_FILTER_TYPE = 'inbox'
export const PROMPT_ENGINEERING_FILTER_TYPE = 'prompt_engineering'
export const QA_ACTIVITY_FILTER_TYPE = 'qa_activity'

export const MESSAGE_FILTERS = [
  { name: 'minMessageCount', defaultValue: '' },
  { name: 'maxMessageCount', defaultValue: '' },
]

// `voipCustomerIds` is deliberately absent: SavedFilterForm clears every
// CALL_FILTERS entry on a switch to a message channel, which would reset a
// value that now applies to sms and chat too.
export const CALL_FILTERS = [
  { name: 'callDuration', defaultValue: '1' },
  { name: 'maxCallDuration', defaultValue: '' },
  { name: 'playbooks', defaultValue: [] },
  { name: 'voipCampaigns', defaultValue: [] },
  { name: 'isWin', defaultValue: '' },
  { name: 'endingSentiment', defaultValue: [] },
  { name: 'attachments', defaultValue: [] },
  { name: 'direction', defaultValue: '' },
  { name: 'dispositions', defaultValue: { selected: [], includes: true } },
  { name: 'agentType', defaultValue: '' },
]

export const COMMON_FIELDS = [
  'name',
  'isDefault',
  'filterPropertiesHeader',
  'channel',
  'dateRange',
  'agents',
  'tags',
  'scorecards',
  'scoredStatus',
  'scorecardThreshold',
  'keywordHeader',
  'keywords',
  'keywordOptions.logic',
  'keywordOptions.side',
  // Which channels offer it is decided by CHANNELS_WITH_CUSTOMER_ID in the
  // schema, so it sits here rather than in a channel-specific list.
  'voipCustomerIds',
]

export const CALL_ONLY_FIELDS = [
  'callDuration',
  'maxCallDuration',
  'isWin',
  'playbooks',
  'voipCampaigns',
  'playbookPropertiesHeader',
  'checklist',
  'deck',
  'notifications',
  'postcall',
  'endingSentiment',
  'attachments',
  'direction',
  'dispositionsHeader',
  'dispositions',
  'includeManagers',
  'agentType',
]

export const MESSAGE_ONLY_FIELDS = ['minMessageCount', 'maxMessageCount']
